export const REDUCERKEY = 'Mentor100'

export const emailValidation = {
  required: 'Please enter email address',
  pattern: {
    value: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    message: 'Please enter valid email address'
  }
}

export const passwordValidation = {
  required: 'Please enter password',
  minLength: {
    value: 8,
    message: 'Password must be at least 8 characters long.'
  }
}


export const dateValidation = {
  required: "Required",
  pattern: {
    value: /^(0[1-9]|1[0-2])\/(0[1-9]|[12][0-9]|3[01])\/\d{4}$/,
    message: "Format must be MM/DD/YYYY"
  }
}

export const phoneValidation = {
  required: "Required",
  pattern: {
    value: /^(\(\d{3}\) \d{3}-\d{4}|\d{10})$/,
    message: "Must be a valid 10-digit number"
  }
}

export const optionalPhoneValidation = {
  pattern: {
    value: /^(\(\d{3}\) \d{3}-\d{4}|\d{10})$/,
    message: "Must be a valid 10-digit number"
  }
}

export const zipValidation = {
  required: "Required",
  pattern: {
    value: /^\d{5}$/,
    message: "Must be a 5-digit number"
  }
}

export const requiredValidation = {
  required: 'Required'
}

export const nameValidation = {
  required: 'Required',
  minLength: { value: 2, message: 'Must be at least 2 characters long' },
  maxLength: { value: 50, message: 'Must not exceed 50 characters' }
}

export const generalTextValidation = {
  required: 'Required',
  minLength: { value: 2, message: 'Must be at least 2 characters long' },
  maxLength: { value: 100, message: 'Must not exceed 100 characters' }
}

export const addressValidation = {
  required: 'Required',
  minLength: { value: 5, message: 'Must be at least 5 characters long' },
  maxLength: { value: 255, message: 'Must not exceed 255 characters' }
}

export const cityValidation = {
  required: 'Required',
  minLength: { value: 2, message: 'Must be at least 2 characters long' },
  maxLength: { value: 100, message: 'Must not exceed 100 characters' }
}

export const longTextValidation = {
  required: 'Required',
  minLength: { value: 10, message: 'Must be at least 10 characters long' },
  maxLength: { value: 5000, message: 'Must not exceed 5000 characters' }
}

export const optionalNameValidation = {
  maxLength: { value: 50, message: 'Must not exceed 50 characters' }
}

export const optionalShortTextValidation = {
  maxLength: { value: 100, message: 'Must not exceed 100 characters' }
}

export const optionalStandardTextValidation = {
  maxLength: { value: 255, message: 'Must not exceed 255 characters' }
}

export const specifyOtherValidation = {
  required: 'Please specify',
  maxLength: { value: 255, message: 'Must not exceed 255 characters' },
  validate: (value) => (value && value.trim().toLowerCase() !== 'other') || "Cannot be 'Other'"
}

export const durationValidation = {
  required: 'Required',
  min: { value: 0, message: 'Cannot be negative' },
  max: { value: 100, message: 'Invalid duration' }
}

export const urlValidation = {
  pattern: {
    value: /^((https?|ftp|smtp):\/\/)?(www\.)?([a-zA-Z0-9-]+\.)+[a-zA-Z0-9]{2,}(:\d{1,5})?(\/[a-zA-Z0-9#_.-]*)*\/?$/,
    message: 'Please enter a valid URL'
  },
  maxLength: { value: 255, message: 'Must not exceed 255 characters' }
}

export const linkedInValidation = {
  pattern: {
    value: /^https?:\/\/(www\.)?linkedin\.com\/in\/.*$/i,
    message: 'Must be a valid LinkedIn profile URL'
  },
  maxLength: { value: 255, message: 'Must not exceed 255 characters' }
}

export const facebookValidation = {
  pattern: {
    value: /^https?:\/\/(www\.)?facebook\.com\/.*$/i,
    message: 'Must be a valid Facebook profile URL'
  },
  maxLength: { value: 255, message: 'Must not exceed 255 characters' }
}

export const twitterValidation = {
  pattern: {
    value: /^https?:\/\/(www\.)?(x)\.com\/.*$/i,
    message: 'Must be a valid Twitter/X profile URL'
  },
  maxLength: { value: 255, message: 'Must not exceed 255 characters' }
}

export const instagramValidation = {
  pattern: {
    value: /^https?:\/\/(www\.)?instagram\.com\/.*$/i,
    message: 'Must be a valid Instagram profile URL'
  },
  maxLength: { value: 255, message: 'Must not exceed 255 characters' }
}

export const states = [
  "AK",
  "AL",
  "AR",
  "AZ",
  "CA",
  "CO",
  "CT",
  "DE",
  "FL",
  "GA",
  "HI",
  "IA",
  "ID",
  "IL",
  "IN",
  "KS",
  "KY",
  "LA",
  "MA",
  "MD",
  "ME",
  "MI",
  "MN",
  "MO",
  "MS",
  "MT",
  "NC",
  "ND",
  "NE",
  "NH",
  "NJ",
  "NM",
  "NV",
  "NY",
  "OH",
  "OK",
  "OR",
  "PA",
  "RI",
  "SC",
  "SD",
  "TN",
  "TX",
  "UT",
  "VA",
  "VT",
  "WA",
  "WI",
  "WV",
  "WY",
];

export const maritalStatusOptions = ['Single', 'Married', 'Divorced', 'Widowed', 'Separated', 'Domestic Partnership', 'Prefer Not to Say'];

export const chapterCommittees = [
  'Mentoring',
  'Youth Achievement Planning',
  'Collegiate 100',
  'Economic Empowerment',
  'Education',
  'Emerging 100',
  'Financial Management',
  'Fundraising',
  'Golf Challenge',
  'Health & Wellness',
  'Marketing & Public Relations',
  'Membership',
  'Mentee Benefit Gala',
  'Parliamentarian & Bylaws',
  'Technology',
  'Other'
]

export const EXCLUDED_ROLES_FROM_MEMBER_APP_REDIRECT = [
  "Alumni",
  "Archive Mentee (No Emails)",
  "Client Admin",
  "Archive Parent (No Emails)",
  "Test Role",
  "Parent",
  "test parent",
  "Alumni-Parent",
  "Mentee",
  "Emerging 100",
  "Collegiate 100",
  "Guest"
];
